import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=ebf2d8a4"
import script from "./project-list.vue?vue&type=script&lang=js"
export * from "./project-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports